import React from 'react'
import { styled } from '@mui/material/styles'
import { Radio as RadioMui } from '@mui/material'

const PREFIX = 'Radio'

const classes = {
  root: `${PREFIX}-root`,
  disabled: `${PREFIX}-disabled`,
  checked: `${PREFIX}-checked`,
}

const StyledRadioMui = styled(RadioMui)(() => {
  return {
    [`& .${classes.root}`]: {
      width: '16px',
      height: '16px',
      fill: '#666666',
      '&$disabled': {
        color: '#888888',
      },
      '&$checked': {
        fill: '#366CD9',
      },
    },
    [`& .${classes.disabled}`]: {},
    [`& .${classes.checked}`]: {},
  }
})

const Radio = props => {
  return (
    <StyledRadioMui
      color="primary"
      classes={{
        root: classes.root,
        disabled: classes.disabled,
        checked: classes.checked,
      }}
      {...props}
    />
  )
}

export default Radio
